import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/account/language')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello /account/language!</div>;
}
